import React from "react";
import { Box, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { LocalizedText } from "../i18n/LocalizedText.js";
const useClasses = makeStyles()((theme) => ({
  layoutWorkspaceDetailsHeaderItem: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    columnGap: theme.spacing(1)
  },
  layoutWorkspaceDetailsHeaderLabel: {
    color: theme.palette.text.secondary,
    flexShrink: 0
  }
}));
const LayoutDetailsHeaderItem = ({ label, children }) => {
  const { classes } = useClasses();
  return /* @__PURE__ */ React.createElement(Box, { className: classes.layoutWorkspaceDetailsHeaderItem }, label && /* @__PURE__ */ React.createElement(Typography, { variant: "body2", className: classes.layoutWorkspaceDetailsHeaderLabel }, /* @__PURE__ */ React.createElement(LocalizedText, { label })), children);
};
export {
  LayoutDetailsHeaderItem
};
//# sourceMappingURL=LayoutDetailsHeaderItem.js.map
